import React from 'react';

import Tabs from '../../generic/Tabs';
import getInfoTooltip from '../../generic/Tooltip/get-info-tooltip';
import Titled from '../../layout/Titled';
import HELP_TEXTS from '../help-texts';
import List from '../List';
import withBrandsAsData from '../with-brands-as-data';

const AllBrandsList = withBrandsAsData(List, {});

const ZmsActiveBrandsList = withBrandsAsData(List, {
  zmsActive: true,
});

const zmsActiveLabel = (
  <>ZMS Active {getInfoTooltip(HELP_TEXTS, 'zmsActive', 'buttons', 'bottom')}</>
);

const tabs = [
  {
    label: zmsActiveLabel,
    value: 'zmsActive',
    content: <ZmsActiveBrandsList />,
  },
  { label: 'All', value: 'all', content: <AllBrandsList /> },
];

/* const createBrandButton = (
  <AuthorizedLink
    to="/brands/add"
    className="btn btn-secondary"
    query={api.addBrand}
  > 
    Create Brand
  </AuthorizedLink>
); */

const ListBrands = () => (
  <Titled title="Brands">
    <Tabs tabs={tabs} id="brandsList" />
  </Titled>
);

export default ListBrands;
